import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="search-dialog"
export default class SearchDialogController extends Controller<HTMLElement> {
  static targets = ["result"]

  declare readonly resultTargets: HTMLElement[]

  get activeResultIndex() {
    return this.resultTargets.findIndex((el) => el.getAttribute("aria-selected") === "true")
  }

  keydown(e: KeyboardEvent) {
    const currentIndex = this.activeResultIndex

    switch (e.code) {
      case "ArrowUp":
        this.#selectItem((currentIndex - 1 + this.resultTargets.length) % this.resultTargets.length)
        e.preventDefault()
        break
      case "ArrowDown":
        this.#selectItem((currentIndex + 1) % this.resultTargets.length)
        e.preventDefault()
        break
      case "Enter":
        this.#openItem(currentIndex)
        e.preventDefault()
    }
  }

  resultTargetConnected(node: HTMLElement) {
    // When the results change, select the first item by default
    if (this.activeResultIndex === -1) {
      this.#selectItem(0)
    }

    // The search input loses focus when clicking on a result, so we need to re-focus it for better UX
    node.addEventListener("click", () => {
      const autoFocusInput = this.element.querySelector<HTMLElement>("input[autofocus]")
      setTimeout(() => {
        if (autoFocusInput) autoFocusInput.focus()
      })
    })
  }

  #openItem(index: number) {
    // If the user clicks on a result, we want to open the first link in that result
    const link = this.resultTargets[index].querySelector<HTMLElement>(":scope a:first-child")
    if (link) link.click()
  }

  #selectItem(index: number) {
    this.resultTargets.forEach((el, i) => {
      const selected = i === index
      el.setAttribute("aria-selected", selected.toString())
    })
  }
}
